var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"google-map"},[(_vm.address)?_c('iframe',{staticClass:"google-map__iframe",staticStyle:{"border":"0"},attrs:{"frameborder":"0","referrerpolicy":"no-referrer-when-downgrade","src":`https://www.google.com/maps/embed/v1/place?key=${_vm.mapKey}&zoom=17&q=${_vm.mapAddress}`,"allowfullscreen":""}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }